import TopRank from "./TopRank";

export default function Leaderboard() {
  return (
    <div className="mx-auto max-w-7xl px-5 lg:px-0">
      <TopRank />
    </div>
  );
}
